import { render, staticRenderFns } from "./QueriesCountIcon.vue?vue&type=template&id=67ae604a&scoped=true"
import script from "./QueriesCountIcon.vue?vue&type=script&lang=ts"
export * from "./QueriesCountIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae604a",
  null
  
)

export default component.exports